import { useTranslation } from 'react-i18next';

interface LoadingOverlayProps {
  open: boolean;
  message?: string;
}

export function LoadingOverlay({ open, message }: LoadingOverlayProps) {
  const { t } = useTranslation();
  const displayMessage = message ?? t('common.loading');
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
      <div className="rounded-sm bg-white h-40 w-72 p-[20px] shadow-xl flex items-center justify-center">
        <p className="text-center text-base font-poppins font-medium text-[#243742]">
          {displayMessage}
        </p>
      </div>
    </div>
  );
}
